import { useMemo } from "react";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import MxAutoCompleteField from "./MxAutoCompleteField/MxAutoCompleteField";
import { MxAutoCompleteFieldProps } from "./MxAutoCompleteField/model/MxAutoCompleteField";
import {
  A_CONDICTION_PROPERTY,
  C_CONDICTION_PROPERTY
} from "@/src-refactor/modules/shared/model/const/property/condition-status.const";

export interface MxSelectConditionPropertyFieldProps
  extends Omit<MxAutoCompleteFieldProps, "items"> {
  isRent: Boolean;
}

const MxSelectConditionPropertyField = (
  props: MxSelectConditionPropertyFieldProps
) => {
  const Items: I_GENERIC_ITEMS[] = useMemo(() => {
    return !props.isRent
      ? A_CONDICTION_PROPERTY
      : [C_CONDICTION_PROPERTY.NEW, C_CONDICTION_PROPERTY.USED];
  }, [props.isRent]);

  return <MxAutoCompleteField {...props} items={Items} />;
};

export default MxSelectConditionPropertyField;
